import React, { useEffect } from 'react'
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline'
import { useLoadboardTheme } from './loadboardTheme'

function DuplicateTabDialog({ duplicateOf, onSwitch, onCancel }) {
	const { theme } = useLoadboardTheme()
	const isLight = theme === 'light'

	useEffect(() => {
		if (!duplicateOf) return
		const onKey = e => {
			if (e.key === 'Escape') onCancel()
		}
		document.addEventListener('keydown', onKey)
		return () => document.removeEventListener('keydown', onKey)
	}, [duplicateOf, onCancel])

	if (!duplicateOf) return null

	const targetTitle = duplicateOf.title || 'another tab'

	return (
		<div
			className="fixed inset-0 z-[60] flex items-start justify-center bg-black/50 pt-32 px-4"
			onClick={onCancel}
			role="dialog"
			aria-modal="true"
			aria-label="Duplicate search"
		>
			<div
				className={`w-full max-w-lg rounded-lg overflow-hidden shadow-xl ${
					isLight ? 'bg-white' : 'bg-[#15202b] ring-1 ring-white/10'
				}`}
				onClick={e => e.stopPropagation()}
			>
				<div className="px-6 pt-6 pb-5 flex items-start gap-4">
					<div
						className={`flex items-center justify-center w-11 h-11 rounded-full shrink-0 ${
							isLight ? 'bg-amber-50' : 'bg-amber-500/15'
						}`}
					>
						<ExclamationTriangleIcon
							className={`h-6 w-6 ${isLight ? 'text-amber-600' : 'text-amber-400'}`}
						/>
					</div>
					<div className="min-w-0">
						<h2
							className={`text-base font-semibold ${
								isLight ? 'text-gray-900' : 'text-gray-100'
							}`}
						>
							This search already exists
						</h2>
						<p
							className={`text-base mt-6 leading-relaxed ${
								isLight ? 'text-gray-600' : 'text-gray-400'
							}`}
						>
							The tab{' '}
							<span
								className={`font-semibold ${
									isLight ? 'text-gray-900' : 'text-gray-200'
								}`}
							>
								"{targetTitle}"
							</span>{' '}
							has the same filters.
						</p>
					</div>
				</div>

				<div className="flex items-center justify-end gap-2 px-6 py-4">
					<button
						type="button"
						onClick={onCancel}
						className={`px-4 py-2 rounded-md text-sm font-medium transition-colors ${
							isLight
								? 'text-gray-700 hover:bg-gray-200'
								: 'text-gray-300 hover:bg-white/[0.08]'
						}`}
					>
						Cancel
					</button>
					<button
						type="button"
						onClick={onSwitch}
						className="px-4 py-2 rounded-md text-sm font-semibold bg-sky-500 text-white hover:bg-sky-600 transition-colors"
					>
						Switch to tab
					</button>
				</div>
			</div>
		</div>
	)
}

export default DuplicateTabDialog
